import axiosInstanceNew from "../lib/axiosinstanceNew";

const PayrollModel = class {
  constructor() {
    this.staticData = [
      {
        _id: "1",
        id: 1,
        name: "Mathematics Advanced - Grade 10",
        status: "Active",
        mode: "SME",
        price_tutor: 12000,
        total_paid: 8000,
        lastPayment: "2024-11-05",
        lastClassCycle: { id: 101 },
        tutorInfo: {
          username: "rajesh_kumar",
          email: "rajesh.kumar@example.com",
        },
        payment_due_date: "2024-11-15",
        cycle_completion_date: "2024-11-10",
        total_bonus_amount: 500,
        total_deduction_amount: 200,
        total_amount: 10000,
        tutorData: {
          first_name: "Rajesh",
          last_name: "Kumar",
        },
        studentData: [{ name: "Rahul Sharma" }, { name: "Priya Patel" }],
        parentData: {
          first_name: "Mr.",
          last_name: "Sharma",
        },
      },
      {
        _id: "2",
        id: 2,
        name: "Science Comprehensive - Grade 9",
        status: "Active",
        mode: "COMBINED",
        price_tutor: 15000,
        total_paid: 12000,
        lastPayment: "2024-11-03",
        lastClassCycle: { id: 102 },
        tutorInfo: {
          username: "priya_singh",
          email: "priya.singh@example.com",
        },
        payment_due_date: "2024-11-20",
        cycle_completion_date: "2024-11-15",
        total_bonus_amount: 300,
        total_deduction_amount: 100,
        total_amount: 12000,
        tutorData: {
          first_name: "Priya",
          last_name: "Singh",
        },
        studentData: [
          { name: "Amit Verma" },
          { name: "Sneha Gupta" },
          { name: "Vikram Singh" },
        ],
        parentData: {
          first_name: "Mrs.",
          last_name: "Verma",
        },
      },
      {
        _id: "3",
        id: 3,
        name: "English Literature - Grade 8",
        status: "Hold",
        mode: "SEPARATE",
        price_tutor: 10000,
        total_paid: 6000,
        lastPayment: "2024-10-28",
        lastClassCycle: { id: 103 },
        tutorInfo: {
          username: "amit_verma",
          email: "amit.verma@example.com",
        },
        payment_due_date: "2024-11-05",
        cycle_completion_date: "2024-10-30",
        total_bonus_amount: 200,
        total_deduction_amount: 50,
        total_amount: 8000,
        tutorData: {
          first_name: "Amit",
          last_name: "Verma",
        },
        studentData: [{ name: "Karan Patel" }],
        parentData: {
          first_name: "Mr.",
          last_name: "Patel",
        },
      },
      {
        _id: "4",
        id: 4,
        name: "Social Studies - Grade 7",
        status: "Completed",
        mode: "SME",
        price_tutor: 9000,
        total_paid: 9000,
        lastPayment: "2024-10-30",
        lastClassCycle: { id: 104 },
        tutorInfo: {
          username: "sunita_gupta",
          email: "sunita.gupta@example.com",
        },
        payment_due_date: "2024-11-01",
        cycle_completion_date: "2024-10-25",
        total_bonus_amount: 400,
        total_deduction_amount: 0,
        total_amount: 9000,
        tutorData: {
          first_name: "Sunita",
          last_name: "Gupta",
        },
        studentData: [{ name: "Meera Joshi" }, { name: "Deepak Kumar" }],
        parentData: {
          first_name: "Mrs.",
          last_name: "Joshi",
        },
      },
      {
        _id: "5",
        id: 5,
        name: "Hindi & Sanskrit - Grade 6",
        status: "Active",
        mode: "COMBINED",
        price_tutor: 11000,
        total_paid: 5500,
        lastPayment: "2024-11-01",
        lastClassCycle: { id: 105 },
        tutorInfo: {
          username: "vikram_patel",
          email: "vikram.patel@example.com",
        },
        payment_due_date: "2024-11-10",
        cycle_completion_date: "2024-11-05",
        total_bonus_amount: 250,
        total_deduction_amount: 150,
        total_amount: 11000,
        tutorData: {
          first_name: "Vikram",
          last_name: "Patel",
        },
        studentData: [
          { name: "Arjun Reddy" },
          { name: "Pooja Nair" },
          { name: "Ravi Kumar" },
        ],
        parentData: {
          first_name: "Mr.",
          last_name: "Reddy",
        },
      },
      {
        _id: "6",
        id: 6,
        name: "Computer Science - Grade 9",
        status: "Discontinued",
        mode: "SEPARATE",
        price_tutor: 13000,
        total_paid: 4000,
        lastPayment: "2024-09-15",
        lastClassCycle: { id: 106 },
        tutorInfo: {
          username: "rajesh_kumar2",
          email: "rajesh.kumar2@example.com",
        },
        payment_due_date: "2024-09-20",
        cycle_completion_date: "2024-09-10",
        total_bonus_amount: 0,
        total_deduction_amount: 300,
        total_amount: 13000,
        tutorData: {
          first_name: "Rajesh",
          last_name: "Kumar",
        },
        studentData: [{ name: "Anjali Sharma" }],
        parentData: {
          first_name: "Mrs.",
          last_name: "Sharma",
        },
      },
      {
        _id: "7",
        id: 7,
        name: "Physics Advanced - Grade 11",
        status: "Active",
        mode: "SME",
        price_tutor: 18000,
        total_paid: 10800,
        lastPayment: "2024-11-07",
        lastClassCycle: { id: 107 },
        tutorInfo: {
          username: "priya_singh2",
          email: "priya.singh2@example.com",
        },
        payment_due_date: "2024-11-12",
        cycle_completion_date: "2024-11-08",
        total_bonus_amount: 600,
        total_deduction_amount: 100,
        total_amount: 18000,
        tutorData: {
          first_name: "Priya",
          last_name: "Singh",
        },
        studentData: [{ name: "Kavita Singh" }, { name: "Rohit Mehta" }],
        parentData: {
          first_name: "Mr.",
          last_name: "Singh",
        },
      },
      {
        _id: "8",
        id: 8,
        name: "Chemistry Lab - Grade 10",
        status: "Active",
        mode: "COMBINED",
        price_tutor: 14000,
        total_paid: 7000,
        lastPayment: "2024-11-10",
        lastClassCycle: { id: 108 },
        tutorInfo: {
          username: "anita_sharma",
          email: "anita.sharma@example.com",
        },
        payment_due_date: "2024-11-15",
        cycle_completion_date: "2024-11-12",
        total_bonus_amount: 350,
        total_deduction_amount: 50,
        total_amount: 14000,
        tutorData: {
          first_name: "Anita",
          last_name: "Sharma",
        },
        studentData: [{ name: "Suresh Yadav" }, { name: "Rekha Tiwari" }],
        parentData: {
          first_name: "Mr.",
          last_name: "Yadav",
        },
      },
      {
        _id: "9",
        id: 9,
        name: "Biology Basics - Grade 8",
        status: "Hold",
        mode: "SEPARATE",
        price_tutor: 9500,
        total_paid: 4750,
        lastPayment: "2024-10-25",
        lastClassCycle: { id: 109 },
        tutorInfo: {
          username: "ravi_gupta",
          email: "ravi.gupta@example.com",
        },
        payment_due_date: "2024-11-01",
        cycle_completion_date: "2024-10-28",
        total_bonus_amount: 150,
        total_deduction_amount: 100,
        total_amount: 9500,
        tutorData: {
          first_name: "Ravi",
          last_name: "Gupta",
        },
        studentData: [{ name: "Neha Jain" }],
        parentData: {
          first_name: "Mrs.",
          last_name: "Jain",
        },
      },
      {
        _id: "10",
        id: 10,
        name: "History & Civics - Grade 9",
        status: "Completed",
        mode: "SME",
        price_tutor: 10500,
        total_paid: 10500,
        lastPayment: "2024-11-02",
        lastClassCycle: { id: 110 },
        tutorInfo: {
          username: "kiran_patil",
          email: "kiran.patil@example.com",
        },
        payment_due_date: "2024-11-05",
        cycle_completion_date: "2024-10-30",
        total_bonus_amount: 200,
        total_deduction_amount: 0,
        total_amount: 10500,
        tutorData: {
          first_name: "Kiran",
          last_name: "Patil",
        },
        studentData: [{ name: "Sanjay Rao" }, { name: "Meera Desai" }],
        parentData: {
          first_name: "Mr.",
          last_name: "Rao",
        },
      },
    ];
  }
  async list(status, query = []) {
    // Return filtered static data based on status
    return new Promise((resolve) => {
      setTimeout(() => {
        let filteredData = this.staticData;
        status = String(status || "");

        if (status.includes("class_status=All")) {
          // Return all data
        } else if (status.includes("class_status=Active")) {
          filteredData = this.staticData.filter(
            (item) => item.status === "Active"
          );
        } else if (status.includes("class_status=Hold")) {
          filteredData = this.staticData.filter(
            (item) => item.status === "Hold"
          );
        } else if (status.includes("class_status=Completed")) {
          filteredData = this.staticData.filter(
            (item) => item.status === "Completed"
          );
        } else if (status.includes("class_status=Discontinued")) {
          filteredData = this.staticData.filter(
            (item) => item.status === "Discontinued"
          );
        } else if (status.includes("class_type=SME")) {
          filteredData = this.staticData.filter((item) => item.mode === "SME");
        } else if (status.includes("class_type=COMBINED")) {
          filteredData = this.staticData.filter(
            (item) => item.mode === "COMBINED"
          );
        } else if (status.includes("class_type=SEPARATE")) {
          filteredData = this.staticData.filter(
            (item) => item.mode === "SEPARATE"
          );
        }

        resolve({
          data: filteredData,
          meta: {
            current_page: 1,
            per_page: 20,
            total_page: Math.ceil(filteredData.length / 20),
            total: filteredData.length,
          },
        });
      }, 500);
    });
  }
  async listfilter(status, filter, query = []) {
    // Handle status + due classes filter
    return new Promise((resolve) => {
      setTimeout(() => {
        let filteredData = this.staticData;
        status = String(status || "");

        // Apply status filter
        if (status.includes("class_status=All")) {
          // Return all data
        } else if (status.includes("class_status=Active")) {
          filteredData = filteredData.filter(
            (item) => item.status === "Active"
          );
        } else if (status.includes("class_status=Hold")) {
          filteredData = filteredData.filter((item) => item.status === "Hold");
        } else if (status.includes("class_status=Completed")) {
          filteredData = filteredData.filter(
            (item) => item.status === "Completed"
          );
        } else if (status.includes("class_status=Discontinued")) {
          filteredData = filteredData.filter(
            (item) => item.status === "Discontinued"
          );
        }

        // Apply due classes filter (getDueClasses=true)
        if (filter.includes("getDueClasses=true")) {
          filteredData = filteredData.filter((item) => {
            const percentage = item.price_tutor
              ? ((item.price_tutor - (item.total_paid || 0)) /
                  item.price_tutor) *
                100
              : 0;
            return percentage > 0; // Classes with outstanding tutor payments
          });
        }

        resolve({
          data: filteredData,
          meta: {
            current_page: 1,
            per_page: 20,
            total_page: Math.ceil(filteredData.length / 20),
            total: filteredData.length,
          },
        });
      }, 500);
    });
  }

  // async list(query = []) {
  //     return (
  //      await axiosInstanceNew.get(`salary/?${new URLSearchParams(query)}`)).data;
  // }
  //  async add(data = []) {
  //    return (
  //     await axiosInstanceNew.post(`salary`,data)).data;
  // }
  async Getlist(id) {
    return (await axiosInstanceNew.get(`class/credit_mapping/view/${id}`)).data;
  }
  async delete(id) {
    return (await axiosInstanceNew.delete(`salary/${id}`)).data;
  }
  async detail(id) {
    return (await axiosInstanceNew.get(`salary/${id}`)).data;
  }
  async edit(id, data = []) {
    return (await axiosInstanceNew.put(`salary/${id}`, data)).data;
  }
};

export default new PayrollModel();
